module.exports={datalist:{empty:"Aucune données",display:"Affichage",loaded:"Toutes les données sont chargées",line:"Nombre de lignes affichées"}};